import ActivityFeed from './ActivityFeed';

export default ActivityFeed;
